<template>
  <div>
    <!-- <v-layout row class="mt-3">
      <v-flex xs10 sm5 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout> -->
    <v-data-table
      :rows-per-page-items="[20, 50, 100]"
      :headers="headers"
      :items="filteredUserItems"
      class="elevation-1 mt-4"
      style="background-color: white; padding: 10px; border-radius: 10px"
      :loading="loading"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color: black"
        >{{ props.header.text }}</template
      >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.no }}</td>
        <td>{{ props.item.wallet_device.device_user.user_first_name }}</td>

        <td class="text-xs-center">
          {{ props.item.wallet_device.device_user.user_last_name }}
        </td>
        <td class="text-xs-right">
          {{ props.item.wallet_device.device_model }}
        </td>
        <td class="text-xs-right">
          {{ props.item.wallet_device.device_serial_number }}
        </td>
        <td class="text-xs-center">
          {{ props.item.wallet_address }}
        </td>
        <td class="text-xs-center">
          {{ props.item.wallet_provider }}
        </td>
        <td class="text-xs-center" v-if="props.item.create_at">
          {{ moment(props.item.create_at).format("YYYY-MM-DD HH:mm") }}
        </td>
        <td v-else></td>
        <td class="text-xs-center" v-if="props.item.update_at">
          {{ moment(props.item.update_at).format("YYYY-MM-DD HH:mm") }}
        </td>
        <td v-else></td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  props: { loading: {}, items: {}, search: {} },
  data() {
    return {
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "First Name",
          align: "center",
          value: "reward",
          sortable: false,
        },
        {
          text: "Last Name",
          align: "center",
          value: "reward",
          sortable: false,
        },
        { text: "Device", value: "amount", sortable: false, align: "center" },
        {
          text: "Serial number/UUID",
          value: "amount",
          sortable: false,
          align: "center",
        },
        {
          text: "Wallet Address",
          value: "amount",
          sortable: false,
          align: "center",
        },
        {
          text: "Wallet Provider",
          value: "amount",
          sortable: false,
          align: "center",
        },
        {
          text: "First Connected",
          value: "use",
          sortable: false,
          align: "center",
        },
        {
          text: "Last Connected",
          value: "value_price",
          sortable: false,
          align: "center",
        },
      ],
      column_items: [
        {
          text: "First Connected",
          value: "create_at",
          sortable: false,
          align: "center",
        },
        {
          text: "Last Connected",
          value: "update_at",
          sortable: false,
          align: "center",
        },
      ],
      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false,
    };
  },
  watch: {
    // reward_report_list: {
    //   handler: function () {
    //     if (this.isSort == false) {
    //       this.asc_desc = "asc";
    //       this.sort_column = "no_default";
    //     }
    //   },
    //   deep: true,
    // },
  },
  computed: {
    ...mapState({
      //   reward_report_list: (state) => state.report.reward_report_list,
      //   reward_report_summary: (state) => state.report.reward_report_summary,
    }),
    filteredUserItems() {
      return this.items.filter(
        (val) =>
          (
            val.wallet_device.device_user.user_first_name +
            " " +
            val.wallet_device.device_user.user_last_name
          )
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.wallet_device.device_model
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.wallet_address
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.wallet_device.device_serial_number
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.wallet_provider.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      //   const send_json_data = {
      //     data: this.reward_report_list,
      //     field: this.sort_column,
      //     asc_desc: this.asc_desc,
      //   };

      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit("report/getExportReportForm");
      this.$store.commit("report/getExportSummaryForm");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    },
    moment,
  },
};
</script>
<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
/* .main-title {
  font-size: 22px;
  font-weight: bold;
}
.text-table {
  font-weight: bold;
  line-height: 30px;
}
.title-store {
  font-size: 19px;
  font-weight: bold;
} */
</style>
